// tslint:disable:no-http-string
import type { AssetOrAssetsFromClipboardData } from 'owa-timestream-asset-sdk-types';
import type { LinkPayload } from '../schema';

export default function createLinkFromClipboardData(
    getData: (format: string) => string
): AssetOrAssetsFromClipboardData<LinkPayload> {
    return (
        extractLinkFromTextLinkPreview(getData('text/link-preview')) ||
        extractLinkFromTextHtml(getData('text/html')) ||
        extractLinksFromTextPlain(getData('text/plain'))
    );
}
function extractLinkFromTextLinkPreview(json: string): AssetOrAssetsFromClipboardData<LinkPayload> {
    try {
        if (json) {
            const { url, title } = JSON.parse(json) as { url?: string; title?: string };
            if (url && isValidProtocol(new URL(url).protocol)) {
                return {
                    type: 'link',
                    payload: { url, title: title || '' },
                };
            }
        }
    } catch {}
    return null;
}

function extractLinkFromTextHtml(html: string): AssetOrAssetsFromClipboardData<LinkPayload> {
    try {
        if (html) {
            const parser = new DOMParser();
            const fragment = parser.parseFromString(html, 'text/html');
            const anchorElement = fragment.querySelector('a[href]') as HTMLAnchorElement;
            if (anchorElement && isValidProtocol(anchorElement.protocol)) {
                const url = anchorElement.href;
                const title = anchorElement.text;
                if (url) {
                    return {
                        type: 'link',
                        payload: { url, title: title || '' },
                    };
                }
            }
        }
    } catch {}
    return null;
}

function extractLinksFromTextPlain(text: string): AssetOrAssetsFromClipboardData<LinkPayload> {
    const lines = text.split(/\r?\n/).filter(x => x);
    const links = lines
        .map(url => {
            try {
                if (url) {
                    const validUrl = new URL(url);
                    if (isValidProtocol(validUrl.protocol)) {
                        return {
                            type: 'link',
                            payload: { url },
                        };
                    }
                }
            } catch {}
            return null;
        })
        .filter(x => x);

    // If more than 50% of the lines are links, return the links.
    // Otherwise let Notes take over.
    return links.length * 2 >= lines.length ? links : null;
}

function isValidProtocol(protocol: string) {
    return protocol == 'https:' || protocol == 'http:';
}
